export interface ObatRpd {
  obat_kode: string | null;
  nama_generik: string;
  dosis: string | null;
  frekuensi: string | null;
  rute: string | null;
  medication_status: string;
}

export interface RpdTerstruktur {
  entries?: { obat?: ObatRpd[] }[];
}

export interface BarisRekonsiliasi {
  obat_id?: string | null;
  regimen_text?: string | null;
  [kolom: string]: unknown;
}

export interface HasilTempelRpd {
  ditambah: number;
  digabung: number;
  sudahAda: number;
  dilewati: number;
}

const STATUS_DIKONSUMSI = ["active", "on-hold", "unknown"];

// c_phar.KODE bisa berspasi di tepi, sedangkan kode yang tersimpan sudah di-trim TrimStrings
export function samaKodeObat(a: unknown, b: unknown): boolean {
  return a != null && b != null && String(a).trim() === String(b).trim();
}

export function regimenRpd(obat: ObatRpd): string {
  return [obat.dosis, obat.frekuensi, obat.rute === "OTHER" ? null : obat.rute]
    .filter(v => v && v.trim())
    .join(" ");
}

export function tempelRpdKeAdmisi(
  detail: BarisRekonsiliasi[],
  rpd: RpdTerstruktur | null
): HasilTempelRpd {
  const hasil: HasilTempelRpd = {
    ditambah: 0,
    digabung: 0,
    sudahAda: 0,
    dilewati: 0
  };
  const daftar = ((rpd && rpd.entries) || []).reduce(
    (acc: ObatRpd[], entry) => acc.concat(entry.obat || []),
    []
  );
  daftar.forEach(obat => {
    if (
      !obat.obat_kode ||
      STATUS_DIKONSUMSI.indexOf(obat.medication_status) === -1
    ) {
      hasil.dilewati++;
      return;
    }
    const regimen = regimenRpd(obat);
    const ada = detail.find(d => samaKodeObat(d.obat_id, obat.obat_kode));
    if (ada) {
      if (!(ada.regimen_text || "").trim() && regimen) {
        ada.regimen_text = regimen;
        hasil.digabung++;
      } else {
        hasil.sudahAda++;
      }
      return;
    }
    detail.push({
      id: null,
      regimen_text: regimen,
      obat_dibawa: "",
      obat_lanjut: "",
      regimen_ranap_text: "",
      kfa_id: null,
      obat_id: obat.obat_kode,
      kfa: null,
      obat: { id: obat.obat_kode, nama: obat.nama_generik }
    });
    hasil.ditambah++;
  });
  return hasil;
}

export function pesanTempelRpd(hasil: HasilTempelRpd): string {
  const bagian = [
    hasil.ditambah ? `${hasil.ditambah} obat ditambahkan` : "",
    hasil.digabung
      ? `${hasil.digabung} melengkapi Regimen Sebelumnya baris yang sudah ada`
      : "",
    hasil.sudahAda ? `${hasil.sudahAda} sudah ada di tabel` : "",
    hasil.dilewati
      ? `${hasil.dilewati} dilewati (selesai/dihentikan atau tanpa kode obat)`
      : ""
  ].filter(Boolean);
  return bagian.length
    ? `RPD: ${bagian.join(", ")}`
    : "RPD Asesmen Awal pasien ini belum berisi obat";
}
